import React from 'react';

const Terms: React.FC = () => {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <div className="container mx-auto py-8 md:py-12">
        <h1 className="text-3xl md:text-4xl font-bold text-center mb-8">
          Termos de Uso
        </h1>
        <p className="text-center text-muted-foreground mb-12">
          Última atualização: 05 de Outubro de 2025
        </p>

        <div className="prose prose-invert max-w-none text-muted-foreground">
          <h2 className="text-2xl font-bold text-primary mt-8 mb-4">1. Aceitação dos Termos</h2>
          <p>
            Bem-vindo à nossa plataforma. Ao acessar e utilizar nossos serviços, você concorda
            em cumprir e estar vinculado aos seguintes Termos de Uso. Se você não concorda com
            qualquer parte destes termos, por favor, não utilize nossa plataforma.
          </p>

          <h2 className="text-2xl font-bold text-primary mt-8 mb-4">2. Alterações nos Termos</h2>
          <p>
            Reservamo-nos o direito de modificar ou substituir estes Termos a qualquer momento,
            a nosso exclusivo critério. Se uma revisão for material, faremos esforços razoáveis
            para fornecer um aviso com pelo menos 30 dias de antecedência antes que quaisquer
            novos termos entrem em vigor. O que constitui uma alteração material será determinado
            a nosso exclusivo critério.
          </p>

          <h2 className="text-2xl font-bold text-primary mt-8 mb-4">3. Sua Conta</h2>
          <p>
            Você é responsável por manter a confidencialidade de sua conta e senha e por
            restringir o acesso ao seu computador. Você concorda em aceitar a responsabilidade
            por todas as atividades que ocorram em sua conta ou senha.
          </p>
          <ul className="list-disc list-inside ml-4">
            <li>Você deve ter a idade legal para jogar em sua jurisdição.</li>
            <li>Você deve fornecer informações precisas e completas durante o registro.</li>
            <li>Você não pode ter mais de uma conta.</li>
          </ul>

          <h2 className="text-2xl font-bold text-primary mt-8 mb-4">4. Propriedade Intelectual</h2>
          <p>
            Todo o conteúdo presente na plataforma, incluindo textos, gráficos, logotipos,
            ícones, imagens, clipes de áudio, downloads digitais, compilações de dados e
            software, é de nossa propriedade ou de nossos fornecedores de conteúdo e é
            protegido por leis de direitos autorais e outras leis de propriedade intelectual.
          </p>

          <h2 className="text-2xl font-bold text-primary mt-8 mb-4">5. Conduta Proibida</h2>
          <p>Você concorda em não:</p>
          <ul className="list-disc list-inside ml-4">
            <li>Utilizar a plataforma para qualquer finalidade ilegal ou não autorizada.</li>
            <li>Violar quaisquer leis em sua jurisdição.</li>
            <li>Engajar-se em qualquer atividade que possa danificar, desabilitar, sobrecarregar ou prejudicar a plataforma.</li>
            <li>Tentar obter acesso não autorizado a qualquer parte da plataforma, outras contas, sistemas de computador ou redes conectadas à plataforma.</li>
          </ul>

          <h2 className="text-2xl font-bold text-primary mt-8 mb-4">6. Limitação de Responsabilidade</h2>
          <p>
            Em nenhuma circunstância seremos responsáveis por quaisquer danos diretos, indiretos,
            incidentais, especiais, consequenciais ou exemplares, incluindo, mas não se limitando
            a, danos por perda de lucros, boa vontade, uso, dados ou outras perdas intangíveis,
            resultantes do uso ou da incapacidade de usar a plataforma.
          </p>

          <h2 className="text-2xl font-bold text-primary mt-8 mb-4">7. Rescisão</h2>
          <p>
            Podemos rescindir ou suspender sua conta imediatamente, sem aviso prévio ou
            responsabilidade, por qualquer motivo, incluindo, sem limitação, se você violar
            os Termos. Você pode rescindir sua conta a qualquer momento, seguindo as instruções na plataforma.
          </p>

          <h2 className="text-2xl font-bold text-primary mt-8 mb-4">8. Lei Aplicável</h2>
          <p>
            Estes Termos serão regidos e interpretados de acordo com as leis da jurisdição
            onde a empresa está registrada, sem levar em consideração seus conflitos de
            disposições legais. Qualquer disputa decorrente ou relacionada a estes Termos
            será submetida à jurisdição exclusiva dos tribunais dessa jurisdição.
          </p>

          <h2 className="text-2xl font-bold text-primary mt-8 mb-4">9. Contato</h2>
          <p>
            Se você tiver alguma dúvida sobre estes Termos de Uso, entre em contato conosco.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Terms;
